// our constants
export const SPOTIFY_TOKENS = 'SPOTIFY_TOKENS';
export const SPOTIFY_TOKENS_BEGIN = 'SPOTIFY_TOKENS_BEGIN';
export const SPOTIFY_ME_BEGIN = 'SPOTIFY_ME_BEGIN';
export const SPOTIFY_ME_SUCCESS = 'SPOTIFY_ME_SUCCESS';
export const SPOTIFY_ME_FAILURE = 'SPOTIFY_ME_FAILURE';
export const SPOTIFY_REFRESH_TOKEN_SUCCESS = 'SPOTIFY_REFRESH_TOKEN_SUCCESS';
export const SPOTIFY_REFRESH_TOKEN_FAILURE = 'SPOTIFY_REFRESH_TOKEN_FAILURE';
export const SPOTIFY_CREATE_PLAYLIST_SUCCESS = 'SPOTIFY_CREATE_PLAYLIST_SUCCESS';
export const SPOTIFY_CREATE_PLAYLIST_FAILURE = 'SPOTIFY_CREATE_PLAYLIST_FAILURE';
export const SPOTIFY_UNFOLLOW_PLAYLIST_SUCCESS = 'SPOTIFY_UNFOLLOW_PLAYLIST_SUCCESS';
export const SPOTIFY_UNFOLLOW_PLAYLIST_FAILURE = 'SPOTIFY_UNFOLLOW_PLAYLIST_FAILURE';
export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const REMOVE_CURRENT_USER = 'REMOVE_CURRENT_USER';
export const SPOTIFY_ADD_TRACKS_SUCCESS = 'SPOTIFY_ADD_TRACKS_SUCCESS';
export const SPOTIFY_ADD_TRACKS_FAILURE = 'SPOTIFY_ADD_TRACKS_FAILURE';
export const SPOTIFY_USER_LOGGED_IN = 'SPOTIFY_USER_LOGGED_IN';
export const SPOTIFY_USER_LOGGED_OUT = 'SPOTIFY_USER_LOGGED_OUT';


export const SPOTIFY_PLAYLIST_SUCCESS = 'SPOTIFY_PLAYLIST_SUCCESS';
export const SPOTIFY_PLAYLIST_FAILURE = 'SPOTIFY_PLAYLIST_FAILURE';
export const SPOTIFY_GET_PLAYLIST_SUCCESS = 'SPOTIFY_GET_PLAYLIST_SUCCESS';
export const SPOTIFY_GET_PLAYLIST_FAILURE = 'SPOTIFY_GET_PLAYLIST_FAILURE';

export const PLAYLIST_CHECK = 'PLAYLIST_CHECK';
export const PLAYLIST_DUPLICATE_MATCH = 'PLAYLIST_DUPLICATE_MATCH';


// WEBPACK FOOTER //
// ./src/actions/ActionTypes.js